/** Textos da seção Planos no admin. */

export const PLAN_ADMIN_PAGE_SUBTITLE =
  'Cadastre um plano gratuito e um plano pago (premium). O pago concentra preços e Stripe para mensal, semestral e anual.';

export const PLAN_ADMIN_CREATE_TITLE = 'Nova oferta de plano';
export const PLAN_ADMIN_EDIT_TITLE = 'Editar oferta de plano';

export const PLAN_ADMIN_KIND_LABEL = 'Tipo de plano';
export const PLAN_ADMIN_KIND_FREE_HELP =
  'Sem Stripe. O utilizador ativa na app com «Começar grátis».';
export const PLAN_ADMIN_KIND_PAID_HELP =
  'Configure preço e Price Stripe para cada periodicidade abaixo.';

export const PLAN_ADMIN_TITLE_LABEL = 'Título';
export const PLAN_ADMIN_TITLE_PLACEHOLDER = 'Ex.: Plano Grátis, RetornaAr Premium';

export const PLAN_ADMIN_SORT_LABEL = 'Ordem de exibição';
export const PLAN_ADMIN_ACTIVE_LABEL = 'Ativo (visível para novas contratações)';

export const PLAN_ADMIN_FREE_LIMITS_SECTION = 'Limites do plano gratuito';

export const PLAN_ADMIN_FREE_MAX_SERVICES_LABEL = 'Limite de serviços';
export const PLAN_ADMIN_FREE_MAX_SERVICES_HELP =
  'Quantidade máxima de serviços que o usuário pode cadastrar com este plano. Ex.: 5 ou 20.';

export const PLAN_ADMIN_VALIDATION_FREE_MAX_SERVICES =
  'Informe o limite de serviços (número inteiro ≥ 0).';

export const PLAN_ADMIN_BILLING_SECTION_ARIA = 'Periodicidades do plano pago';

export const PLAN_ADMIN_VARIANT_PRICE_LABEL = 'Preço (por ciclo)';
export const PLAN_ADMIN_VARIANT_PRICE_HELP =
  'Valor cobrado em cada cobrança desta periodicidade. Use vírgula para centavos.';

export const PLAN_ADMIN_TOAST_CREATED = 'Plano criado.';
export const PLAN_ADMIN_TOAST_UPDATED = 'Plano atualizado.';
export const PLAN_ADMIN_TOAST_DELETED = 'Plano excluído.';
export const PLAN_ADMIN_TOAST_LOAD_FAILED =
  'Não foi possível carregar os planos. Tente novamente.';
export const PLAN_ADMIN_TOAST_ACTIVATED = 'Plano ativado.';
export const PLAN_ADMIN_TOAST_DEACTIVATED = 'Plano desativado.';

export const PLAN_ADMIN_EMPTY_LIST =
  'Nenhum plano cadastrado. Crie o plano gratuito e o plano pago.';

export const PLAN_ADMIN_VALIDATION_TITLE = 'Informe o título do plano.';
export const PLAN_ADMIN_VALIDATION_SORT = 'Ordem de exibição deve ser um número inteiro ≥ 0.';
export const PLAN_ADMIN_VALIDATION_VARIANT_PRICE = (periodLabel: string) =>
  `Preço inválido em ${periodLabel}. Use valores como 79,90.`;
export const PLAN_ADMIN_VALIDATION_STRIPE_ID = (periodLabel: string) =>
  `ID do Price Stripe inválido em ${periodLabel}. Deve começar com price_.`;
export const PLAN_ADMIN_VALIDATION_STRIPE_TEST_ID = (periodLabel: string) =>
  `ID do Price Stripe (teste) inválido em ${periodLabel}.`;
